<template>
  <div class="head-container">
    <el-row>
    <el-col :span="12">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if='item.redirect==="noredirect"||index==levelList.length-1' class="no-redirect">{{item.name}}</span>
        <router-link v-else :to="item.redirect||item.path">{{item.name}}</router-link>
      </el-breadcrumb-item>
      <!-- <el-breadcrumb-item>注册用户总数：{{userNum}}</el-breadcrumb-item> -->
    </el-breadcrumb>
    </el-col>
    <el-col :span="12">
      <div class="user-header">
        <el-dropdown  @command="handleCommand" >
          <el-button type="primary" icon="el-icon-user-solid" size="small" @click="handleclick">
            {{userInfo.role_name}}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="pasdedit">修改密码</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="info" icon="el-icon-error" size="small" @click="handlelogout">logout</el-button>
      </div>
    </el-col>
    </el-row>
    <el-dialog   title="修改密码"  :visible.sync="dialogpassdeditvisible" :modal="false" center width="30%">
      <el-form ref="pasdform" :rules="updateRules" :model="pasdform" label-width="100px" width="200px">
        <el-form-item label="原始密码" prop="password">
          <el-input v-model="pasdform.password" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newpassword">
          <el-input v-model="pasdform.newpassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="newpassword2">
          <el-input v-model="pasdform.newpassword2" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogpassdeditvisible = false">取 消</el-button>
          <el-button type="primary" @click="pasdedit('pasdform')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    created() {
      this.getBreadcrumb()
      this.getInfo()
      // this.getUserList()
    },
    data() {
      var checkBlank =(rule, value, callback) => {
        if (!value) {
          return callback(new Error());
        }
        value = value.trim()
        if (value=='') {
          return callback(new Error());
        }
         return callback();
      }
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } else {
          if (this.pasdform.newpassword2 !== '') {
            this.$refs.pasdform.validateField('newpassword2');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入新密码'));
        } else if (value != this.pasdform.newpassword) {
          callback(new Error('两次输入新密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        levelList: null,
        userNum:0,
        dialogpassdeditvisible:false,
        pasdform:{
          password:'',
          newpassword:'',
          newpassword2:'',
        },
        updateRules:{
          password:[{required: true,validator:checkBlank, message: '请输入原始密码', trigger: 'blur' }],
          newpassword:[{required: true,validator:validatePass, trigger: 'blur' }],
          newpassword2:[{required: true,validator:validatePass2, trigger: 'blur' }],
        },
        userInfo:{},
      }
    },
    methods: {
      getBreadcrumb() {
        let matched = this.$route.matched.filter(item => item.name)
        this.levelList = matched
      },
      handlelogout(){
        this.axios.post("/sysuser/loginout").then(res=>{
          if(res.data.code==1){
            this.$message({type: 'success',message:'退出成功'});
            localStorage.removeItem('router')
            
            this.$router.push(`/`)
          }
        })
      },
      getInfo(){
        this.axios.post("/sysuser/getInfo").then(res=>{
          if(res.data.code==-1){
            this.$message({type: 'error',message:'尚未登录,将跳转至登录页'});
            this.$router.push(`/`)
          }else if(res.data.code==1){
            this.userInfo = res.data.data
            localStorage.setItem("userInfo", JSON.stringify(res.data.data))
          }
        })
      },
      getUserList(){
        this.axios.post("/sysback/getRegiData").then(res=>{
          if(res.data.code==1){
            this.userNum = res.data.data.num
          }
        })
      },
      handleclick(){
        //alert('button click');
      },
      handleCommand(command){
        switch(command){
          case "pasdedit":
            this.dialogpassdeditvisible = true
            break
        }
      },
      pasdedit(formname){
        this.$refs[formname].validate((valid) => {
          if(valid){
            this.axios.post("/sysuser/pasdedit",this.pasdform).then(res=>{
              if(res.data.code==1){
                this.dialogpassdeditvisible = false
                this.$message({type: 'success',message:'修改成功'});
                this.$refs[formname].resetFields()
              }else{
                this.$message({type: 'error',message:res.data.msg});
              }
            })
          }
        })
      },
    },
    watch: {
      $route() {
        this.getBreadcrumb()
      }
    }
  }
</script>
<style>
.user-header{
  display: inline-block;
  vertical-align: middle;
  text-align: right;
  width: calc(100% - 90px);
  height: 60px;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/head.vue